import { logger } from "@artis/logger";

import {
  type InitOptions,
  datadogInit,
  posthogInit,
  sentryInit,
  sumologicInit,
  getDeploymentEnv,
} from "./integrations";
import { router } from "../../App";

const env = getDeploymentEnv();

const options: InitOptions = {
  service: "webapp-2.0",
  isProduction: env === "prod",
  env,
  version: import.meta.env.VITE_GIT_TAG || import.meta.env.VITE_GIT_SHA,
  sha: import.meta.env.VITE_GIT_SHA,
  tag: import.meta.env.VITE_GIT_TAG || "",
  branch: import.meta.env.VITE_GIT_BRANCH || "",
};

posthogInit(options);

if (env === "prod" || env === "preprod") {
  datadogInit(options);
  sentryInit(options, router);
  sumologicInit(options);
}

logger.withContext({ tags: ["webapp"] });
